var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.605 17.795V8.442h-5.2C1.898 8.442.666 9.8.666 11.46v9.051c0 1.66 1.232 3.017 2.737 3.017h1.369v4.526l4.106-4.526h6.844c1.505 0 2.737-1.357 2.737-3.017v-2.745c-.09.021-.181.032-.273.032H8.605v-.002zM25.305.9h-12.32c-1.505 0-2.737 1.357-2.737 3.017v12.068h9.581l4.106 4.525v-4.525h1.37c1.505 0 2.737-1.356 2.737-3.017V3.917C28.042 2.257 26.81.9 25.304.9z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconGrey);
export default __webpack_public_path__ + "static/media/chat-icon-grey.d832c94750f3384ecb574ced5fa84992.svg";
export { ForwardRef as ReactComponent };